import path from "./path.js";
import math from "core/math";
/**
 * Draw a circle with given `center` and `radius`.
 * @public
 * @method drawCircle
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {HTMLElement} element - The DOM Element to draw on
 * @param {Object} center - `{ x, y }` in either pixel or canvas coordinates.
 * @param {number} radius - The circle's radius in canvas units.
 * @param {Object} options - See {@link path}
 * @param {String} [coordSystem='pixel']
 * @returns {undefined}
 */
export default function(
  context,
  element,
  center,
  radius,
  options,
  coordSystem = "pixel"
) {
  if (coordSystem === "pixel") {
    center = math.coordinate.pixelToCanvas(element, center);
  }

  path(context, options, context => {
    context.arc(center.x, center.y, radius, 0, 2 * Math.PI);

    // 바깥쪽 선 색
    context.strokeStyle = options.color || "#00ff00";
    // 안쪽 채울 색
    context.fillStyle = options.color || "#00ff00";

    context.fill();   // 내부 채우기
    context.stroke(); // 외곽선 그리기
  });
}